import { agentCloudTestConfigPlan } from '../../../../atoms/atoms';
import type {
  AgentCloudTestConfigChange,
  AgentTestOperation,
  PlanApprovalStatus,
} from '../../../../types';
import { pluralizeString } from '../../../../utils/common';
import { createPlanApprovalRenderer } from '../applyTestConfigPlanShared/ApplyTestConfigPlanToolRenderer';
import { TEST_MANAGEMENT_PATH } from '../applyTestConfigPlanShared/sharedUtils';
import {
  formatCloudTestChangeLabel,
  formatCloudTestChangeSummary,
} from './utils';

const PREVIEW_PATH = `${TEST_MANAGEMENT_PATH}/cloud-agent-preview`;

const getHeaderLabel = (
  status: PlanApprovalStatus | undefined,
  operation: AgentTestOperation,
  count: number,
): string => {
  if (status === 'confirmed') return 'Plan approved';
  if (status === 'rejected') return 'Plan rejected';
  if (operation === 'create') {
    return `Create ${pluralizeString(count, 'new test', 'new tests')}`;
  }
  if (operation === 'delete') {
    return `Delete ${pluralizeString(count, 'test', 'tests')}`;
  }
  return `Configuration changes for ${pluralizeString(count, 'test', 'tests')}`;
};

const getApproveLabel = (operation: AgentTestOperation): string =>
  operation === 'create'
    ? 'Create'
    : operation === 'delete'
    ? 'Delete'
    : 'Approve';

const applyCloudTestConfigPlanApprovalRenderer =
  createPlanApprovalRenderer<AgentCloudTestConfigChange>({
    planAtom: agentCloudTestConfigPlan,
    previewPath: PREVIEW_PATH,
    returnPath: TEST_MANAGEMENT_PATH,
    formatChangeLabel: formatCloudTestChangeLabel,
    formatChangeSummary: formatCloudTestChangeSummary,
    getHeaderLabel,
    getApproveLabel,
  });

export default applyCloudTestConfigPlanApprovalRenderer;
